import { FormSection } from 'components/form-section/form-section'
import { Typography, theme } from 'antd'
import { useTranslate, useTouchDetector, useWindowDimensions } from 'utils'
import { CheckOutlined, CopyOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { flowAppointmentVariables, flowCustomerVariables, flowLocationVariables, flowResourceVariables, flowServiceVariables, flowShopVariables } from 'data'
import { RWContainer, RWElement, VerticalContainer } from 'components/styled'
const { Text, Paragraph } = Typography

export const FlowVariables = () => {

    //hooks:
    const { __ } = useTranslate()
    const { isTouchscreen } = useTouchDetector()
    const [ hoveredText, setHoveredText ] = useState('')
    const { SM } = useWindowDimensions()
    const { token: {
        marginXS,
        paddingXXS,
        padding,
        paddingLG,
        colorTextTertiary,
        colorInfoActive
    }} = theme.useToken()

    const getVariableJSX = (variable: string) => (
        <Text
            key={variable}
            style={{
                minHeight: 30,
                display: 'flex',
                alignItems: 'center'
            }}
            copyable={hoveredText === variable || isTouchscreen ? {
                icon: [
                    <CopyOutlined  key={1} style={{ padding: paddingXXS, color: colorTextTertiary }}/>,
                    <CheckOutlined key={2} style={{ padding: paddingXXS, color: colorInfoActive   }}/>
                ],
                tooltips: [__`copy`, __`copied`]
            } : undefined}
            onMouseEnter={() => setHoveredText(variable)}
            onMouseLeave={() => setHoveredText('')}
        >
            {variable}
        </Text>
    )

    return (
        <FormSection
            title={__`available_variables`}
            footer={
                <Paragraph
                    type='secondary'
                    style={{
                        margin: 0,
                        padding: SM ? `0 ${paddingLG}px` : `0 ${padding}px`
                    }}
                >
                    * {__`for_adding_lists_resource_you_should_include_variables_inside_the_each_helper`}
                </Paragraph>
            }
            style={{ height: '100%' }}
        >

            <RWContainer style={{ alignItems: 'flex-start', gap: marginXS }}>

                <RWElement numberOfElements={5} breakPoint={200}>
                    
                    <Text style={{ fontWeight: 'bold' }}>
                        {__`location`}
                    </Text>
                    {flowLocationVariables.map(variable => getVariableJSX(variable))}
                    
                </RWElement>

                <RWElement numberOfElements={5} breakPoint={200}>
                    
                    <Text style={{ fontWeight: 'bold' }}>
                        {__`service`}
                    </Text>
                    {flowServiceVariables.map(variable => getVariableJSX(variable))}
                    
                </RWElement>

                <RWElement numberOfElements={5} breakPoint={200}>

                    <VerticalContainer style={{ gap: marginXS }}>

                        <div>
                            <Text style={{ fontWeight: 'bold' }}>
                                {__`resource`} *
                            </Text>
                            {flowResourceVariables.map(variable => getVariableJSX(variable))}
                        </div>

                        <div>
                            <Text style={{ fontWeight: 'bold' }}>
                                {__`shop`}
                            </Text>
                            {flowShopVariables.map(variable => getVariableJSX(variable))}
                        </div>

                    </VerticalContainer>
                    
                </RWElement>
                            
                <RWElement numberOfElements={5} breakPoint={200}>
                    
                    <Text style={{ fontWeight: 'bold' }}>
                        {__`customer`}
                    </Text>
                    {flowCustomerVariables.map(variable => getVariableJSX(variable))}

                </RWElement>

                <RWElement numberOfElements={5} breakPoint={200}>

                    <Text style={{ fontWeight: 'bold' }}>
                        {__`appointment`}
                    </Text>
                    {flowAppointmentVariables.map(variable => getVariableJSX(variable))}

                </RWElement>

            </RWContainer>

        </FormSection>
    )

}
